import {sync} from "vuex-pathify";
import {gsap} from "gsap";

export default {
    computed: {
        leave_animate_status: sync('func_data/leave_animate_status'),
        back_animate_status: sync('func_data/back_animate_status'),

    },
    watch: {
        leave_animate_status: {
            immediate: true,
            handler(value, old) {
                if (value) {
                    this.leaveAnimation()
                }
            }
        },
        back_animate_status: {
            immediate: true,
            handler(value, old) {
                if (value) {
                    this.backLeaveAnimation()
                }
            }
        }
    },
    methods: {
        enterGsap() {
            return;
        },
        leaveGsap() {
            return;
        },
        backEnterGsap() {
            return;
        },
        backLeaveGsap() {
            return;
        },

        async triggerEnterAnimation() {
            // console.log('triggerEnterAnimation')
            this.$store.set('func_data/enter_animate_status', true)
            if (this.$store.get('func_data/back_enter_status')) {
                this.backEnterAnimation();
                await this.$store.dispatch('form/sleep', this.step._leave_animate_duration)
            }else{
                this.enterAnimation();
                await this.$store.dispatch('form/sleep', this.step._enter_animate_duration)
            }
            this.$store.set('func_data/enter_animate_status', false)
        },
        enterAnimation() {
            // console.log('IMPORTANT!!=enterAnimation')
            return this.enterGsap();
        },
        leaveAnimation() {
            // console.log('IMPORTANT!!=leaveAnimation')
            return this.leaveGsap();
        },
        backEnterAnimation() {
            // console.log('IMPORTANT!!=backEnterAnimation')
            return this.backEnterGsap();
        },
        backLeaveAnimation() {
            // console.log('IMPORTANT!!=backLeaveAnimation')
            return this.backLeaveGsap();
        }
    },

    async mounted() {
        await this.triggerEnterAnimation()
    }
}
